import { RouterModule } from "@angular/router";
import { CommonModule } from "@angular/common";
import * as Models from "./models";
import {
  Component,
  EventEmitter,
  Input,
  Output, OnInit,
} from "@angular/core";

@Component({
  selector: "app-sidenav-menu-item",
  imports: [CommonModule, RouterModule],
  templateUrl: "./sidenav-menu-item.component.html",
  styleUrls: ["./sidenav-menu-item.component.scss"]
})
export class SidenavMenuItemComponent implements OnInit {
  @Input({ required: true }) item!: Models.ISidenavMenu;
  @Input() displayCount = true;
  @Input() notificationCount!: string;
  eSlidenavMenu = Models.ESlidenavMenu;

  ngOnInit(): void {
    this.notificationCount = parseInt(this.notificationCount) > 9 ? '+9' : this.notificationCount;
  }

  @Output() click: EventEmitter<Models.ISidenavMenu> =
    new EventEmitter<Models.ISidenavMenu>();

  onItemClicked() {
    this.click.emit(this.item);
  }
}
